module.exports = function() {
	return new Worker(__webpack_public_path__ + "1000ff26c2a31b00f8b9.worker.js");
};


/*****************
 ** WEBPACK FOOTER
 ** ./scripts/workers/sway.worker.js
 ** module id = 383
 ** module chunks = 0
 **/